// ---- Config ----
const LC_FREE_SHIP_THRESHOLD = 6000; // 60 € en cents

// ---- Cart JSON helper ----
async function getCartJSON() {
  return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(r => r.json());
}

// ---- Progress bar ----
async function updateProgressBar() {
  const root = document.querySelector('.lc-cart-progress');
  if (!root) return;

  try {
    const cart = await getCartJSON();
    const threshold = Number(root.dataset.threshold || LC_FREE_SHIP_THRESHOLD) || 0; // 6000
    const total = Number(cart.total_price || 0); // en cents
    const left = Math.max(threshold - total, 0);

    // Variante "reste" : la barre est presque pleine quand il manque peu
    let pctReached = 0;
    if (threshold > 0) {
      pctReached = Math.min(Math.max((1 - left / threshold) * 100, 0), 100);
    }

    const bar = root.querySelector('.lc-cart-progress__bar');
    const txt = root.querySelector('.lc-cart-progress__text');

    if (bar) bar.style.width = pctReached.toFixed(2) + '%';

    if (txt) {
      txt.textContent = left === 0
        ? '🎉 Livraison offerte !'
        : `Plus que ${(left / 100).toFixed(2).replace('.', ',')} € pour la livraison offerte.`;

      // Accessibilité (optionnel)
      root.setAttribute('role', 'progressbar');
      root.setAttribute('aria-valuemin', '0');
      root.setAttribute('aria-valuemax', String(threshold / 100));
      root.setAttribute('aria-valuenow', String((total / 100).toFixed(2)));
    }
  } catch (e) {
    // silencieux
  }
}

// Expose pour pouvoir l'appeler depuis theme.liquid
window.updateProgressBar = updateProgressBar;

// Injecte la barre si jamais elle n'est pas présente (sécurité)
function ensureBarMount() {
  if (document.querySelector('#CartDrawer .lc-cart-progress')) return;

  const drawerHeader = document.querySelector('#CartDrawer .drawer__header');
  if (!drawerHeader) return;

  const div = document.createElement('div');
  div.className = 'lc-cart-progress';
  div.setAttribute('data-threshold', String(LC_FREE_SHIP_THRESHOLD));
  div.innerHTML = `
    <div class="lc-cart-progress__text" aria-live="polite"></div>
    <div class="lc-cart-progress__track">
      <div class="lc-cart-progress__bar" style="width:0%"></div>
    </div>
  `;
  drawerHeader.insertAdjacentElement('afterend', div);
}

// ---- Init: observe le drawer pour réagir à chaque refresh Dawn ----
function initCartProgress() {
  // S'assure que la barre existe dès le départ + premier calcul
  ensureBarMount();
  updateProgressBar();

  // 1) Observer #CartDrawer (re-render du contenu)
  const attachInnerObserver = () => {
    const target = document.getElementById('CartDrawer');
    if (!target) return false;
    let raf = 0;
    const mo = new MutationObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        ensureBarMount();
        updateProgressBar();
      });
    });
    mo.observe(target, { childList: true, subtree: true });
    // calcul immédiat à l'attache
    ensureBarMount();
    updateProgressBar();
    return true;
  };

  // 2) Observer <cart-drawer> pour réagir à l’ouverture (attribut [open])
  const attachOpenObserver = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    const mo = new MutationObserver((muts) => {
      if (muts.some(m => m.type === 'attributes' && m.attributeName === 'open')) {
        ensureBarMount();
        updateProgressBar();
      }
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    return true;
  };

  // 3) Si #CartDrawer/cart-drawer n’existent pas encore, on surveille le DOM jusqu’à leur arrivée
  if (!attachInnerObserver() || !attachOpenObserver()) {
    const boot = new MutationObserver(() => {
      const ok1 = attachInnerObserver();
      const ok2 = attachOpenObserver();
      if (ok1 && ok2) boot.disconnect();
    });
    boot.observe(document.documentElement, { childList: true, subtree: true });
  }

  // 4) Écoute d'évènements potentiels du thème
  document.addEventListener('cart:refresh', updateProgressBar);
  document.addEventListener('cart:updated', updateProgressBar);
  document.addEventListener('cart:change', updateProgressBar);
}

document.addEventListener('DOMContentLoaded', initCartProgress);
